import React, {useState} from "react";
import {useCreditSelector} from "../../../../stores/product/product.store";
import {CreditState} from "../../../../stores/credit/credit-state.interface";
import {useCreditDispatch} from "../../../../stores/credit/credit.store";
import {setShipping} from "../../../../stores/credit/credit.reducer";
import {fetchTotalThunk} from "../../../../stores/credit/thunks/fetch-total.thunk";
import {SelectCustom} from "../../../Select";
import {PickupInterface} from "../../../../interfaces/credit/shipping-method.interface";

interface MppProps {
    pickups: PickupInterface[];
    additionalText?: string;
}

const Mpp: React.FC<MppProps> = ({ pickups, additionalText }) => {
    const translateText = useCreditSelector((state: CreditState) => state.text);
    const dispatch = useCreditDispatch();
    const [selectedPickup, setSelectedPickup] = useState<{ label: string; value: string } | null>(null);

    const onChangePickup = (option: { label: string; value: string } | null) => {
        setSelectedPickup(option);
        dispatch(setShipping(
            {
                zone: '',
                cityId: '',
                pickup: option!.value,
            }
        ));
        dispatch(fetchTotalThunk());
    };

    return (
        <div>
            <div>
                <label htmlFor="region" className="text-sm font-medium mb-3 block text-black">{ translateText.selectCity }</label>
                <SelectCustom
                    options={ pickups.map(p => ({ label: p.name, value: p.name })) }
                    onChange={ onChangePickup } value={ selectedPickup }
                    placeholder={ translateText.select }
                />
            </div>
            {additionalText && <div className="mt-5">
                <p className="mb-5" dangerouslySetInnerHTML={{__html: additionalText}}></p>
                <ol className="list-disc ml-5">
                    {pickups.map(pickup => <li className="mb-3"
                                               dangerouslySetInnerHTML={{__html: pickup.name}}></li>)}
                </ol>
            </div>}
        </div>
    );
}

export default Mpp;